import React, { useContext, useState, useEffect } from 'react'

import FullScreenPopup from '../FullScreenPopup'
import { useFormik } from 'formik'
import { Button } from '@mui/material'
import CustomTable from '../../molecules/CustomTable'
import PrimaryButton from '../../atoms/PrimaryButton'
import CustomDialog from '../Dialog'
import ProductContext from '../../../context/product/productContext'
import CommonContext from '../../../context/common/commonContext'
import ReportContext from '../../../context/report/reportContext'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import { useTranslation } from 'react-i18next'
import Loaders from '../../molecules/Loaders'

const LogsHistory = (props) => {
    const productContext = useContext(ProductContext)

    const {
        search_allapilogs,
        getAllAPILogs,
        clearResponse: clearAllBidHistory,
    } = productContext

    const { t } = useTranslation()
    const [changeStatus, setChangeStatus] = React.useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    let data = props.data

    const commonContext = useContext(CommonContext)
    const { bidHistoryValue, clearBidHistoryValue } = commonContext

    const { getAllExportDownload } = useContext(ReportContext)
    const [reload, setReload] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [tableBody, setTableBody] = useState([])
    const [projectData, setProjectData] = useState(null)

    const formikData = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            project: props?.project || 'NPS',
            filters: {
                action_id: {
                    value: '',
                    type: 'in',
                    field: 'al.action_id',
                },
                admin_id: {
                    value: '',
                    type: 'in',
                    field: 'al.admin_id',
                },
                action_name: {
                    value: 'listingPrintLabel',
                    type: 'in',
                    field: 'al.action',
                },
            },
        },
        onSubmit: (values) => {
            getCreditHistory(values)
        },
    })

    const resetForm = () => {
        formikData.resetForm()
        setReload(!reload)
    }

    useEffect(() => {
        if (data?.id) {
            formikData.values.filters.action_id.value = parseInt(data?.id)
            formikData.values.page = 1
            setIsLoading(true)
            getAllAPILogs(formikData.values, 'imageEditPage')
        } else {
            resetForm()
        }
    }, [data?.id])

    useEffect(() => {
        if (search_allapilogs && search_allapilogs.from === 'imageEditPage') {
            setIsLoading(false)
            if (search_allapilogs.records.length) {
                setTableBody(search_allapilogs.records)
            } else {
                setTableBody([])
                //setTableBody(search_allapilogs.records.length ? search_allapilogs.records : [])
            }

            // if (search_allapilogs.projectRecords) {
            //     setProjectData(search_allapilogs.projectRecords)
            // }
        }
    }, [search_allapilogs])

    let tableValues = []

    tableValues.push(
        {
            field: 'project_id',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: t('Product ID'),
        },
        {
            field: 'as_employees_emp_firstname',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: t('First Name'),
        },
        {
            field: 'as_employees_emp_lastname',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: t('Last Name'),
        },
        {
            field: 'as_employees_emp_email',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: t('Email'),
        },
        {
            field: 'requested_at',
            type: 'datetimesecond',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: t('Requested Date'),
        },
        {
            field: 'lot_id',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: t('Lot ID'),
        },
        {
            field: 'auctionid',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: t('Event ID'),
        }
    )

    const tableActions = []

    return props.noModal ? (
        <CustomTable
            formik={formikData.values}
            tableBody={tableBody}
            tableValues={tableValues}
            tableActions={tableActions}
            allData={search_allapilogs}
            changeTableFunction={getAllAPILogs}
            hideCompactView={true}
            fromVariable="imageEditPage"
        />
    ) : (
        <>
            <FullScreenPopup
                modaltitle={t(`Logs History`)}
                open={data.popup === true}
                handleClose={() => props.function(false, 0)}
            >
                {isLoading ? (
                    <Loaders isLoading={isLoading} name="home" />
                ) : (
                    <>
                        <div className="wallet">
                            <div className="fspBody">
                                <div className="bhTopInfo">
                                    {projectData ? (
                                        <div className="bhProdDetails">
                                            <div className="bhpLt">
                                                <img
                                                    src={`${global.images_url}${projectData.avatar}`}
                                                    alt={projectData?.title}
                                                    onError={(e) =>
                                                        (e.target.src =
                                                            '/assets/images/noimage.png')
                                                    }
                                                />
                                            </div>
                                            <div className="bhpRt">
                                                <h6>
                                                    Lot Id:{' '}
                                                    <span>
                                                        {projectData?.id}
                                                    </span>
                                                </h6>
                                                <h6>
                                                    Lot Title:{' '}
                                                    <span>
                                                        {projectData?.title}
                                                    </span>
                                                </h6>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>

                                <CustomTable
                                    formik={formikData.values}
                                    tableBody={tableBody}
                                    tableValues={tableValues}
                                    tableActions={tableActions}
                                    allData={search_allapilogs}
                                    changeTableFunction={getAllAPILogs}
                                    fromVariable="imageEditPage"
                                />
                            </div>
                        </div>
                    </>
                )}
            </FullScreenPopup>
        </>
    )
}

export default LogsHistory
